import classNames from "classnames";
import css from "./imageInAspectRatio.module.css";

export function ImageInAspectRatio({
  className,
  src,
  alt,
  "data-json-path": dataJsonPath,
}: SquareImageProps) {
  return (
    <div className={classNames(className)} data-json-path={dataJsonPath}>
      <img className={css.imageInAspectRatioImage} src={src} alt={alt} />
    </div>
  );
}

export interface SquareImageProps {
  className?: string | string[] | Record<string, boolean>;
  src: string;
  alt?: string;
  "data-json-path"?: string;
}
